import axios from 'axios';

const httpCmsService = axios.create({
    baseURL: process.env.REACT_APP_CMS_URL,
});

export default httpCmsService;
